import { FormGroup, FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../_services/global.service';
import { ResponseStructure } from '@iq-central-front-end/share';
import { StaffService } from '../../../_services/staff.service';
import { AuthService } from '../../../_services/auth.service';

@Component({
  selector: 'iq-central-front-end-setting-profile',
  templateUrl: './setting-profile.component.html',
  styleUrls: ['./setting-profile.component.scss'],
})
export class SettingProfileComponent implements OnInit {
  IsHidden: boolean = false;
  profileForm: FormGroup;
  sub: Subscription = new Subscription();
  profile: any;
  user: any;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _global: GlobalService,
    private _staff: StaffService,
    private readonly authService: AuthService
  ) {
    this.user = this.authService.getLoggedInUser();
  }

  ngOnInit(): void {
    this.getResolvedData();
    this.initProfileForm();
    this.profileForm.disable();
  }
  initProfileForm() {
    this.profileForm = this.fb.group({
      address: [this.profile.address],
      companyType: [this.profile.companyType],
      contactPerson: [this.profile.contactPerson],
      description: [this.profile.description],
      name: [this.profile.name],
      phoneNumber: [this.profile.phoneNumber],
      website: [this.profile.website],
    });
  }
  getResolvedData() {
    this.sub.add(
      this.route.data.subscribe((res) => {
        this.profile = res['resolvedData'].profile['responseResult'];
      })
    );
  }
  toggleDisabled() {
    var x = document.getElementById('update').innerText;
    console.log(x);
    if (x === 'Edit') {
      document.getElementById('update').innerText = 'Cancel';
    } else {
      document.getElementById('update').innerText = 'Edit';
    }
    if (x === 'Edit') {
      if (this.user.admin) {
        this.profileForm.enable();
      } else {
        this.profileForm.controls['phoneNumber'].enable();
      }
    } else {
      if (this.user.admin) {
        this.profileForm.disable();
      } else {
        this.profileForm.controls['phoneNumber'].disable();
      }
    }

    this.IsHidden = !this.IsHidden;
  }

  updateProfile() {
    const payload = this.profileForm.value;

    this._global.showSpinner();
    this._staff.updateEnterpriseUser(payload).subscribe({
      next: (res: ResponseStructure) => {
        this._global.successHandlerWithObject(res);
        this.toggleDisabled();
      },
    });
  }
}
